import { Instagram, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { IMG, LINKS } from "@/constants/bbAssets";
import { scrollToId } from "@/lib/scroll";

const FOOT_LINKS = [
  { label: "Ways to Play", id: "ways" },
  { label: "Why Beach Break", id: "why" },
  { label: "Meet Tess", id: "tess" },
  { label: "FAQ", id: "faq" },
];

export const Footer = () => {
  const navigate = useNavigate();
  return (
  <footer className="bg-deep text-cream border-t border-cream/10 pb-10">
    <div className="max-w-7xl mx-auto px-5 md:px-8 pt-14">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="inline-block bg-cream rounded-xl p-2.5">
            <img src={IMG.logo} alt="Beach Break Sand Volleyball" className="h-12 w-auto rounded" data-testid="footer-logo" />
          </div>
          <p className="mt-5 font-display uppercase text-2xl leading-tight">Beach Break Volleyball</p>
          <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-cream/60">
            Tampa, Florida • Summer 2027
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-sun">Explore</p>
          <ul className="mt-4 space-y-2.5">
            {FOOT_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="font-mono text-[11px] uppercase tracking-[0.16em] text-cream/80 hover:text-sun transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-sun">Stay in touch</p>
          <ul className="mt-4 space-y-3">
            <li>
              <a
                data-testid="footer-instagram-link"
                href={LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.16em] text-cream/80 hover:text-sun transition-colors"
              >
                <Instagram className="w-4 h-4" /> Instagram — {LINKS.instagramHandle}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email-link"
                href={`mailto:${LINKS.email}`}
                className="inline-flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.16em] text-cream/80 hover:text-sun transition-colors"
              >
                <Mail className="w-4 h-4" /> Contact — {LINKS.email}
              </a>
            </li>
          </ul>
          <button
            data-testid="footer-cta"
            onClick={() => scrollToId("join")}
            className="mt-6 inline-flex items-center gap-2 bg-sun text-deep font-mono text-[11px] uppercase tracking-[0.18em] px-6 py-3 rounded-full hover:bg-cream transition-colors duration-200"
          >
            Join the Interest List
          </button>
        </div>
      </div>

      <p className="mt-16 font-display uppercase text-center leading-none text-[clamp(1.9rem,7.5vw,5.5rem)] text-outline-cream select-none" data-testid="footer-marquee-text">
        Good Vibes × Volleyball
      </p>

      <div className="mt-10 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-cream/50">
          © Summer 2027 Beach Break Volleyball
        </p>
        <button
          data-testid="footer-admin-link"
          onClick={() => navigate("/admin")}
          className="font-mono text-[9px] uppercase tracking-[0.2em] text-cream/50 hover:text-sun transition-colors"
        >
          Owner Login
        </button>
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] text-cream/50">
          Good Vibes × Volleyball
        </p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
